/*
 * @FilePath: /mall-fe/src/hooks/useDopIntegration.ts
 * @Description: 统一管理 DOP 接入相关逻辑的 Hook
 */
import { useEffect } from 'react';
import dopAppInstance, { isInDop, rewriteWindowOpen } from 'libs/dopUtil.js';

/**
 * 统一管理 DOP 接入相关逻辑的 Hook
 *
 * 功能包括：
 * 1. DOP URL 初始化和跳转逻辑
 * 2. DOP 监听初始化（rewriteWindowOpen 和 changePath 监听）
 */
export function useDopIntegration() {
  /**
   * 初始化 DOP URL 处理逻辑
   * 处理 refer=dop 和 jumpInDop 参数
   */
  const initDopUrl = async () => {
    const urlSearchStr = window.location.search;
    try {
      const inDop = await isInDop();
      if (!inDop) {
        return;
      }

      if (urlSearchStr.includes('refer=dop')) {
        let destUrl = window.location.href?.replace('refer=dop', '');
        // 解析 transferUrl 参数，如果存在则使用 transferUrl 作为 destUrl
        const urlParams = new URLSearchParams(urlSearchStr);
        const transferUrl = urlParams.get('transferUrl');

        // 检查是否需要登录（通过 URL 判断，不依赖 userInfo）
        // 如果需要登录，则跳转到登录页
        const needLogin = !document.cookie.includes('token'); // 简单判断
        if (needLogin) {
          const { accessToken } = await dopAppInstance.getToken();
          if (transferUrl) {
            destUrl = decodeURIComponent(transferUrl);
          }
          destUrl = destUrl.includes('?')
            ? `${destUrl}&idaasToken=${accessToken}`
            : `${destUrl}?idaasToken=${accessToken}`;
          destUrl = `/sso/login?return_url=${encodeURIComponent(destUrl)}`;

          const resultUrl = `${window.location.origin}${destUrl}`;
          console.log('resultUrl:', resultUrl);
          // window.selfOpen(resultUrl);
          window.location.href = resultUrl;
        } else {
          // NOTE: 已登录，并且存在 transferUrl 参数，则直接跳转
          if (transferUrl) {
            window.location.href = transferUrl;
          }
        }
      } else if (urlSearchStr.includes('jumpInDop=true')) {
        // 保证第一次登录进来不重复定位菜单
        dopAppInstance.changeMenu({
          menuKey: '/?refer=dop',
        });
      }
    } catch (e) {
      console.error('dop check: ', e);
    }
  };

  /**
   * 初始化 DOP 监听
   * 包括 rewriteWindowOpen 和 changePath 监听
   */
  const initDopListeners = async () => {
    // 本地开发环境不执行
    if (process.env.NODE_ENV === 'development') {
      return;
    }

    rewriteWindowOpen();

    isInDop().then((res) => {
      console.log('isInDop: ', res);
      if (res) {
        // dop监听初始化
        dopAppInstance?.on('changePath', ({ data }) => {
          console.log('change path listen... mallfe', data);
          const { shortUrl } = data;
          window.open(shortUrl, '_top');
        });
      }
    });
  };

  // DOP URL 初始化 - 组件挂载时执行
  useEffect(() => {
    initDopUrl();
  }, []);

  // DOP 监听初始化 - 组件挂载时执行
  useEffect(() => {
    initDopListeners();
  }, []);
}
